export const expensesKeys = {
	all: (circleId: string) => ['expenses', circleId],
	list: (circleId: string) => [...expensesKeys.all(circleId), 'list'],
	summary: (circleId: string) => [...expensesKeys.all(circleId), 'summary'],
	add: () => ['expenses', 'add'],
	delete: () => ['expenses', 'delete'],
	update: () => ['expenes', 'update'],
	detail: (expenseId: string) => ['expenses', expenseId],
};
